
export const mockCreators = [
  {
    id: 'creator-001',
    slug: 'layla-al-rashid-actress-uae',
    name: 'Layla Al-Rashid',
    role: 'Actress',
    country: 'UAE',
    avatar: 'https://public.readdy.ai/ai/img_res/374d55f2e2df5aa54bfbbf147662bbc4.jpg',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20photo%20of%20film%20set%20with%20elegant%20Middle%20Eastern%20actress%20in%20period%20costume%20professional%20movie%20production%20environment%20with%20warm%20golden%20lighting&width=1200&height=400&seq=creator001cover&orientation=landscape',
    followers: 2450000,
    following: 89,
    verified: true,
    recentWork: 'Noor',
    bio: 'Award-winning actress known for powerful dramatic performances in contemporary Arab cinema. Passionate about authentic storytelling and representing strong female characters.',
    projects: 24,
    awards: 8,
    yearsActive: 8,
    specialties: ['Drama', 'Romance', 'Historical'],
    languages: ['Arabic', 'English', 'French'],
    location: 'Dubai, UAE',
    fanRating: 4.9,
    totalReviews: 12450,
    responseRate: 85,
    avgResponseTime: '2 hours',
    socialMedia: {
      instagram: '@layla_alrashid',
      twitter: '@laylaactor',
      website: 'www.layla-alrashid.com'
    }
  },
  {
    id: 'creator-002',
    slug: 'ahmed-hassan-director-egypt',
    name: 'Ahmed Hassan',
    role: 'Director',
    country: 'Egypt',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Middle%20Eastern%20film%20director%20with%20artistic%20expression%20creative%20portrait%20with%20cinematic%20lighting%20and%20contemporary%20style%20clean%20white%20background&width=200&height=200&seq=creator002&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Film%20director%20on%20movie%20set%20with%20camera%20equipment%20and%20crew%20professional%20cinematography%20environment%20with%20dramatic%20lighting%20and%20modern%20film%20production%20setup&width=1200&height=400&seq=creator002cover&orientation=landscape',
    followers: 1890000,
    following: 156,
    verified: true,
    recentWork: 'Desert Winds',
    bio: 'Visionary director specializing in contemporary Arab storytelling. Known for innovative cinematography and compelling narratives that resonate with audiences worldwide.',
    projects: 18,
    awards: 12,
    yearsActive: 12,
    specialties: ['Drama', 'Thriller', 'Social Commentary'],
    languages: ['Arabic', 'English'],
    location: 'Cairo, Egypt',
    fanRating: 4.8,
    totalReviews: 8920,
    responseRate: 72,
    avgResponseTime: '4 hours',
    socialMedia: {
      instagram: '@ahmed_hassan_director',
      twitter: '@ahmedfilms',
      website: 'www.ahmedhassan.film'
    }
  },
  {
    id: 'creator-003',
    slug: 'sara-mahmoud-producer-lebanon',
    name: 'Sara Mahmoud',
    role: 'Producer',
    country: 'Lebanon',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20successful%20Middle%20Eastern%20woman%20producer%20with%20business%20attire%20executive%20portrait%20with%20modern%20lighting%20and%20professional%20background%20clean%20white%20background&width=200&height=200&seq=creator003&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20film%20production%20office%20with%20Middle%20Eastern%20woman%20producer%20reviewing%20scripts%20and%20storyboards%20professional%20entertainment%20industry%20workspace%20with%20contemporary%20design&width=1200&height=400&seq=creator003cover&orientation=landscape',
    followers: 956000,
    following: 234,
    verified: true,
    recentWork: 'City of Dreams',
    bio: 'Innovative producer bringing fresh perspectives to Arab cinema. Committed to supporting emerging talent and diverse storytelling across the region.',
    projects: 25,
    awards: 6,
    yearsActive: 10,
    specialties: ['Independent Films', 'Drama', 'Documentary'],
    languages: ['Arabic', 'English', 'French'],
    location: 'Beirut, Lebanon',
    fanRating: 4.7,
    totalReviews: 5670,
    responseRate: 68,
    avgResponseTime: '6 hours',
    socialMedia: {
      instagram: '@sara_mahmoud_producer',
      twitter: '@saraproduces',
      website: 'www.saramahmoud.com'
    }
  },
  {
    id: 'creator-004',
    slug: 'omar-khalil-actor-jordan',
    name: 'Omar Khalil',
    role: 'Actor',
    country: 'Jordan',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20handsome%20Middle%20Eastern%20actor%20with%20charismatic%20smile%20leading%20man%20portrait%20with%20dramatic%20lighting%20and%20elegant%20styling%20clean%20white%20background&width=200&height=200&seq=creator004&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Handsome%20Middle%20Eastern%20actor%20in%20character%20costume%20on%20film%20set%20professional%20movie%20production%20with%20cinematic%20lighting%20and%20period%20drama%20styling&width=1200&height=400&seq=creator004cover&orientation=landscape',
    followers: 3120000,
    following: 67,
    verified: true,
    recentWork: 'The Last Garden',
    bio: 'Versatile actor with a passion for authentic character portrayal. Known for bringing depth and nuance to every role, from romantic leads to complex antiheroes.',
    projects: 15,
    awards: 4,
    yearsActive: 9,
    specialties: ['Drama', 'Action', 'Comedy'],
    languages: ['Arabic', 'English'],
    location: 'Amman, Jordan',
    fanRating: 4.9,
    totalReviews: 15780,
    responseRate: 90,
    avgResponseTime: '1 hour',
    socialMedia: {
      instagram: '@omar_khalil_actor',
      twitter: '@omarkhalil',
      website: 'www.omarkhalil.com'
    }
  },
  {
    id: 'creator-005',
    slug: 'fatima-al-zahra-writer-morocco',
    name: 'Fatima Al-Zahra',
    role: 'Writer',
    country: 'Morocco',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20intelligent%20Middle%20Eastern%20woman%20writer%20with%20thoughtful%20expression%20literary%20portrait%20with%20soft%20lighting%20and%20artistic%20background%20clean%20white%20background&width=200&height=200&seq=creator005&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20writer%20workspace%20with%20Middle%20Eastern%20woman%20at%20desk%20surrounded%20by%20books%20and%20scripts%20artistic%20literary%20environment%20with%20warm%20natural%20lighting&width=1200&height=400&seq=creator005cover&orientation=landscape',
    followers: 478000,
    following: 145,
    verified: false,
    recentWork: 'Whispers of Time',
    bio: 'Talented screenwriter crafting compelling narratives that explore the human condition through an Arab lens. Specializing in character-driven stories with emotional depth.',
    projects: 8,
    awards: 2,
    yearsActive: 5,
    specialties: ['Drama', 'Historical', 'Romance'],
    languages: ['Arabic', 'French', 'English'],
    location: 'Casablanca, Morocco',
    fanRating: 4.6,
    totalReviews: 2340,
    responseRate: 78,
    avgResponseTime: '3 hours',
    socialMedia: {
      instagram: '@fatima_writes',
      twitter: '@fatimawriter',
      website: ''
    }
  },
  {
    id: 'creator-006',
    slug: 'youssef-nader-cinematographer-saudi',
    name: 'Youssef Nader',
    role: 'Cinematographer',
    country: 'Saudi Arabia',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Middle%20Eastern%20cinematographer%20with%20creative%20expression%20artistic%20portrait%20with%20professional%20lighting%20and%20modern%20style%20clean%20white%20background&width=200&height=200&seq=creator006&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20cinematographer%20with%20camera%20equipment%20on%20film%20set%20technical%20movie%20production%20environment%20with%20cinematic%20lighting%20and%20modern%20filming%20gear&width=1200&height=400&seq=creator006cover&orientation=landscape',
    followers: 623000,
    following: 89,
    verified: true,
    recentWork: 'Desert Winds',
    bio: 'Master cinematographer known for stunning visuals and innovative camera work. Bringing cinematic excellence to Arab productions with a unique visual style.',
    projects: 22,
    awards: 7,
    yearsActive: 14,
    specialties: ['Cinematography', 'Visual Storytelling', 'Technical Innovation'],
    languages: ['Arabic', 'English'],
    location: 'Riyadh, Saudi Arabia',
    fanRating: 4.8,
    totalReviews: 4560,
    responseRate: 65,
    avgResponseTime: '5 hours',
    socialMedia: {
      instagram: '@youssef_cinematography',
      twitter: '@youssefcamera',
      website: 'www.youssefnader.com'
    }
  },
  {
    id: 'creator-007',
    slug: 'nadia-farouk-actress-tunisia',
    name: 'Nadia Farouk',
    role: 'Actress',
    country: 'Tunisia',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20beautiful%20Middle%20Eastern%20actress%20with%20elegant%20expression%20sophisticated%20portrait%20photography%20with%20studio%20lighting%20and%20glamorous%20styling%20clean%20white%20background&width=200&height=200&seq=creator007&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Middle%20Eastern%20actress%20in%20period%20costume%20on%20historical%20film%20set%20professional%20movie%20production%20with%20authentic%20period%20details%20and%20cinematic%20lighting&width=1200&height=400&seq=creator007cover&orientation=landscape',
    followers: 1278000,
    following: 112,
    verified: true,
    recentWork: 'Carthage Dreams',
    bio: 'Rising star in Arab cinema known for versatility and emotional depth. Passionate about representing strong female characters and authentic Arab stories.',
    projects: 9,
    awards: 3,
    yearsActive: 6,
    specialties: ['Drama', 'Historical', 'Independent Films'],
    languages: ['Arabic', 'French', 'English'],
    location: 'Tunis, Tunisia',
    fanRating: 4.7,
    totalReviews: 7890,
    responseRate: 82,
    avgResponseTime: '2 hours',
    socialMedia: {
      instagram: '@nadia_farouk',
      twitter: '@nadiaactor',
      website: 'www.nadiafarouk.com'
    }
  },
  {
    id: 'creator-008',
    slug: 'khalid-al-mansouri-director-iraq',
    name: 'Khalid Al-Mansouri',
    role: 'Director',
    country: 'Iraq',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Middle%20Eastern%20film%20director%20with%20intense%20artistic%20expression%20creative%20portrait%20with%20dramatic%20lighting%20and%20contemporary%20style%20clean%20white%20background&width=200&height=200&seq=creator008&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Film%20director%20reviewing%20footage%20on%20monitors%20in%20post-production%20studio%20professional%20editing%20environment%20with%20modern%20technology%20and%20cinematic%20workspace&width=1200&height=400&seq=creator008cover&orientation=landscape',
    followers: 867000,
    following: 203,
    verified: true,
    recentWork: 'Baghdad Stories',
    bio: 'Acclaimed director focusing on social realism and contemporary Iraqi narratives. Known for powerful storytelling and authentic portrayals of Middle Eastern life.',
    projects: 11,
    awards: 5,
    yearsActive: 8,
    specialties: ['Social Drama', 'Documentary', 'Political Thriller'],
    languages: ['Arabic', 'English', 'Kurdish'],
    location: 'Baghdad, Iraq',
    fanRating: 4.6,
    totalReviews: 3450,
    responseRate: 70,
    avgResponseTime: '4 hours',
    socialMedia: {
      instagram: '@khalid_almansouri_director',
      twitter: '@khalidfilms',
      website: 'www.khalidalmansouri.com'
    }
  }
];

export const creatorRoles = ['Actress', 'Actor', 'Director', 'Producer', 'Writer', 'Cinematographer'];
export const creatorCountries = ['UAE', 'Egypt', 'Lebanon', 'Jordan', 'Morocco', 'Saudi Arabia', 'Tunisia', 'Iraq'];

export const getCreatorBySlug = (slug: string) => {
  return mockCreators.find(c => c.slug === slug || c.id === slug);
};

export const getCreatorById = (id: string) => {
  return mockCreators.find(c => c.id === id);
};

export const getCreatorsByRole = (role: string) => {
  return mockCreators.filter(c => c.role.toLowerCase() === role.toLowerCase());
};

export const getCreatorsByCountry = (country: string) => {
  return mockCreators.filter(c => c.country === country);
};

export const getSimilarCreators = (creatorId: string, limit: number = 3) => {
  const creator = getCreatorById(creatorId);
  if (!creator) return [];
  return mockCreators
    .filter(c => c.id !== creatorId && c.role === creator.role)
    .slice(0, limit);
};
